export enum JobRole {
    President = 'President',
    Director = 'Director',
    AdvisorSales = 'AdvisorSales',
    AdvisorRent = 'AdvisorRent',
    AdministratorRent = 'AdministratorRent',
    Assistant = 'Assistant',
    PropertyHunter = 'PropertyHunter',
    Other = 'Other',
}
